import produce, { Draft } from "immer";
import { combineReducers } from "redux";

import { ACTIONS, ActionType } from "actions/user/types";
import { LoadingState } from "types/api";
import { SubordinatesState, ProfileState } from "./types";

const initialProfile = {
    data: {
        userId: "",
        managerId: "",
        teamMembersSize: 0,
        isManager: false,
    },
    status: LoadingState.idle,
};

const profile = produce((state: Draft<ProfileState>, action: ActionType) => {
    switch (action.type) {
        case ACTIONS.GET_USER_PROFILE_REQUEST:
            state.status = LoadingState.loading;
            break;
        case ACTIONS.GET_USER_PROFILE_SUCCESS: {
            state.status = LoadingState.success;
            state.data = action.payload;
            break;
        }
        case ACTIONS.GET_USER_PROFILE_FAILURE:
            state.status = LoadingState.failure;
            break;
    }
}, initialProfile);

const initialSubordinates = {
    status: LoadingState.idle,
};

const subordinates = produce((state: Draft<SubordinatesState>, action: ActionType) => {
    switch (action.type) {
        case ACTIONS.GET_SUBORDINATES_REQUEST:
            state.status = LoadingState.loading;
            break;
        case ACTIONS.GET_SUBORDINATES_SUCCESS: {
            state.status = LoadingState.success;
            state.data = action.payload;
            break;
        }
        case ACTIONS.GET_SUBORDINATES_FAILURE:
            state.status = LoadingState.failure;
            break;
    }
}, initialSubordinates);

export default combineReducers({
    profile,
    subordinates,
});
